'use strict'

import Api from '@/api/sms.js'

const state = {
  loading: false,
  error: null,
  templatesRemind: [],
  renderRemind: [],
  templatesInvite: [],
  renderInvite: [],
  validTemplates: {},
  remind: {
    lastSaveTimestamp: null,
    lastUpdateTimestamp: null
  },
  invite: {
    lastSaveTimestamp: null,
    lastUpdateTimestamp: null
  },
  max_chars_exceeded: false
}

const actions = {
  fetchSmsRemind ({commit, dispatch}, {vacancyId}) {
    commit('fetchSmsRemind')

    return Api.fetchSmsRemind(vacancyId)
      .then(data => commit('fetchSuccessSmsRemind', data))
      .catch(err => {
        commit('fetchFailureSmsRemind', err)
        dispatch('global/setError', err, {root: true})
        throw err;
      })
  },

  updateSmsRemind ({commit, dispatch}, {vacancyId, templates}) {
    commit('saveSmsRemind')

    return Api.updateSmsRemind({vacancyId, templates})
      .then(data => commit('saveSuccessSmsRemind', data))
      .catch(err => {
        commit('saveFailureSmsRemind', err)
        dispatch('global/setError', err, {root: true})
        throw err;
      })
  },

  renderSmsRemind ({commit, dispatch}, {vacancyId, templates}) {
    commit('saveSmsRemind')

    return Api.renderSmsRemind({vacancyId, templates})
      .then(data => commit('renderSuccessSmsRemind', data))
      .catch(err => {
        commit('saveFailureSmsRemind', err)
        dispatch('global/setError', err, {root: true})
        throw err;
      })
  },

  changeOneRemindSms ({ commit }, item) {
    commit('changeOneRemindSms', item)
  },

  fetchSmsInvite ({commit, dispatch}, {vacancyId}) {
    commit('fetchSmsInvite')

    return Api.fetchSmsInvite(vacancyId)
      .then(data => commit('fetchSuccessSmsInvite', data))
      .catch(err => {
        dispatch('global/setError', err, {root: true})
        commit('fetchFailureSmsInvite', err)
        throw err;
      })
  },

  updateSmsInvite ({commit, dispatch}, {vacancyId, templates}) {
    commit('saveSmsInvite')

    return Api.updateSmsInvite({vacancyId, templates})
      .then(data => commit('saveSuccessSmsInvite', data))
      .catch(err => {
        dispatch('global/setError', err, {root: true})
        commit('saveFailureSmsInvite', err)
        throw err;
      })
  },

  renderSmsInvite ({commit, dispatch}, {vacancyId, templates}) {
    commit('saveSmsInvite')

    return Api.renderSmsInvite({vacancyId, templates})
      .then(data => commit('renderSuccessSmsInvite', data))
      .catch(err => {
        dispatch('global/setError', err, {root: true})
        commit('saveFailureSmsInvite', err)
        throw err;
      })
  },

  changeOneInviteSms ({ commit }, item) {
    commit('changeOneInviteSms', item)
  }
}

const mutations = {
  fetchSmsRemind (state) {
    state.loading = true
  },

  fetchSuccessSmsRemind (state, data) {
    state.templatesRemind = data
    state.loading = false
  },

  fetchFailureSmsRemind (state, err) {
    state.error = err
    state.loading = false
  },

  saveSmsRemind (state) {
    state.loading = true
  },

  saveSuccessSmsRemind (state, data) {
    if (data) {
      state.templatesRemind = state.templatesRemind.map(t => {
        if (t.id === data.id) {
          Object.assign(t, data)
        }

        return t
      })

      state.remind.lastSaveTimestamp = new Date()
    }
    state.loading = false
  },

  renderSuccessSmsRemind (state, data) {
    if (data) {
      state.renderRemind = data
    }
    state.loading = false
  },

  saveFailureSmsRemind (state, err) {
    state.loading = false
    state.error = err
    console.error(err)
  },

  changeOneRemindSms (state, item) {
    state.templatesRemind = state.templatesRemind
      .map(i => i.id === item.id ? item : i)
    state.remind.lastUpdateTimestamp = new Date()
  },

  fetchSmsInvite (state) {
    state.loading = true
  },

  fetchSuccessSmsInvite (state, data) {
    state.templatesInvite = data
    state.loading = false
  },

  fetchFailureSmsInvite (state, err) {
    state.error = err
    state.loading = false
  },

  saveSmsInvite (state) {
    state.loading = true
  },

  saveSuccessSmsInvite (state, data) {
    if (data) {
      state.templatesInvite = state.templatesInvite.map(t => {
        if (t.id === data.id) {
          Object.assign(t, data)
        }

        return t
      })
      state.invite.lastSaveTimestamp = new Date()
    }
    state.loading = false
  },

  renderSuccessSmsInvite (state, data) {
    if (data) {
      state.renderInvite = data
    }
    state.loading = false
  },

  saveFailureSmsInvite (state, err) {
    state.loading = false
    state.error = err
    console.error(err)
  },

  changeOneInviteSms (state, item) {
    state.templatesInvite = state.templatesInvite
      .map(i => i.id === item.id ? item : i)
    state.invite.lastUpdateTimestamp = new Date()
  },

  templateIsValid (state, {index, isValid}) {
    state.validTemplates = Object.assign({}, state.validTemplates, {[index]: isValid})
  },

  resetChangesTimestamps (state) {
    state.remind.lastSaveTimestamp = null
    state.remind.lastUpdateTimestamp = null
    state.invite.lastSaveTimestamp = null
    state.invite.lastUpdateTimestamp = null
  },

  clear(state) {
    state.loading = false;
    state.error = null;
    state.templatesRemind = [];
    state.renderRemind = [];
    state.templatesInvite = [];
    state.renderInvite = [];
    state.validTemplates = {};
  },

  set_max_chars_exceeded(state, val) {
    state.max_chars_exceeded = val;
  }
}

const getters = {
  error (state) {
    return state.error
  },

  loading (state) {
    return state.loading
  },

  templatesRemind (state) {
    return state.templatesRemind
  },

  renderRemind (state) {
    return state.renderRemind
  },

  templatesInvite (state) {
    return state.templatesInvite
  },

  renderInvite (state) {
    return state.renderInvite
  },

  max_chars_exceeded (state) {
    return state.max_chars_exceeded
  },

  isValid (state) {
    return Object.values(state.validTemplates).filter(v => !v).length === 0
  },

  haveUnsavedChanges (state) {
    return state.invite.lastUpdateTimestamp > state.invite.lastSaveTimestamp ||
           state.remind.lastUpdateTimestamp > state.remind.lastSaveTimestamp
  }
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
